import $ from "jquery";

const formAjax = () => {
    $("#sort_sort").on("change", function (e) {
        const parameters = {
            sort: $(this).val(),
            difficulty: getQueryParameter('difficulty'),
        };

        updateContent(parameters);
    });

    $("#filter_form").on("change", function (e) {
        const parameters = {
            sort: getQueryParameter('sort'),
            difficulty: $(this).serializeArray().map(item => item.value).join(','),
        };

        updateContent(parameters);
    });

    function updateContent(parameters) {
        const queryString = $.param(parameters);

        window.history.pushState(null, "", "?" + queryString);

        $.ajax({
            type: "POST",
            url: "/wp/wp-admin/admin-ajax.php",
            dataType: "html",
            data: {
                action: "handle_posts",
                posttype: 'section',
                parameters: parameters,
            },
            success: function (res) {
                $("#js-resultlist").html(res);
                $("#js-posts-number").html($('.card_section').length);
            },
        });
    }

    function getQueryParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name) || '';
    }
};

export default formAjax;
